import { LegalLayout } from "@/pages/legal/LegalLayout";

export default function AccessibilityStatement() {
  return (
    <LegalLayout
      title="Accessibility Statement"
      path="/accessibility"
      seoTitle="Accessibility Statement | Legacy Spa"
      seoDescription="Legacy Spa is committed to an accessible, inclusive web experience for all visitors."
      intro="Our commitment to an inclusive, accessible experience."
      sections={[
        {
          heading: "Our Commitment",
          body: [
            "Legacy Spa is committed to providing a website that is accessible to the widest possible audience, regardless of ability or technology.",
          ],
        },
        {
          heading: "Measures We Take",
          body: ["This website has been built with accessibility in mind, including:"],
          list: [
            "Keyboard navigation and a skip-to-content link",
            "Visible focus states for interactive elements",
            "Semantic headings and landmark regions",
            "Form labels, required-field indicators and accessible error messages",
            "Sufficient color contrast against our brand palette",
            "Reduced-motion support for visitors who prefer it",
            "Descriptive alternative text for meaningful images",
          ],
        },
        {
          heading: "Ongoing Effort",
          body: [
            "Accessibility is an ongoing effort. We continue to review and improve the experience. Feedback will be welcomed through the contact page once live inquiry handling is activated.",
          ],
        },
      ]}
    />
  );
}
